import api from './api'
import { IPartner } from './loadPartners'

const loadPartner = (partnerId: string): Promise<IPartner> => api<IPartner>({ path: `/partners/${partnerId}` })

export default loadPartner
